<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="正在上传"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <el-dialog :title="title" :visible="isShowImport" width='550px' :close-on-click-modal='false' :show-close="true"
      :before-close='closeDialog'>
      <el-form ref="ruleForm" :model="ruleForm" label-width="100px">
        <el-form-item label="导入数据" prop='fileName'>
          <div class="fileName">
            <a href="https://qn.maintain.base.gintell.cn/template/%E7%89%A9%E6%96%99%E4%BF%A1%E6%81%AF%E6%A8%A1%E6%9D%BF.xlsx"
              class="downloadText" target="_self">下载数据模板</a>&nbsp;
            <el-upload :action="$apis.material.importMaterial" :auto-upload="true" :data="{ projectId: projectId }"
              :on-success="successFile" :before-upload='beforeUpload' :on-error='fileError' :show-file-list="false"
              accept=".xls,.xlsx" :headers="headInfo">
              <el-button type="primary" class="ml20">上传excel</el-button>
            </el-upload>
          </div>
          <!-- <p>{{ruleForm.fileName}}</p> -->
        </el-form-item>
        <div class="warning">
          <i class="el-icon-warning"></i>
          <span>请先下载数据模板，根据模板表填入数据后再上传</span>
        </div>
      </el-form>
      <div v-if="isShowtable">
        <p class="resultText2" v-if="resData.error">导入失败{{ resData.error }}条</p>
        <p class="resultText" v-else>
          导入成功{{ resData.success }}条
        </p>
        <el-table v-if="resultList.length" ref="resultTable" class="global-table" max-height="600" :data="resultList">
          <el-table-column label="数据位置" prop="position" min-width="100" align='center'
            showOverflowTooltip></el-table-column>
          <el-table-column label="失败原因" prop="error" min-width="100" align='center'
            showOverflowTooltip></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ImportData',
  components: {
  },
  props: {
    isShowImport: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: String,
      default: ''
    },
    templateUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      headInfo: {
        token: this.$store.state.token || '',
        customer: this.$store.state.customer || ''
      },
      fullscreenLoading: false,
      title: '导入',
      //  templateUrl = ''
      isShowtable: false,
      resultList: [],
      ruleForm: {},
      resData: {
        success: 0,
        error: 0
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() { },
  methods: {
    // 文件上传之前
    beforeUpload(file) {
      const size = file.size / 1024 / 1024 < 10
      const type = 'xls,xlsx'
      const name = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
      if (type.indexOf(name) === -1) {
        this.$message({
          message: '上传文件只能是 .xls,.xlsx 格式!',
          type: 'warning'
        })
        return false
      } else if (!size) {
        this.$message({
          message: '上传文件大小不能超过 10MB!',
          type: 'warning'
        })
        return false
      } else {
        this.fullscreenLoading = true
        return true
      }
    },
    // 文件上传失败
    fileError(error) {
      this.fullscreenLoading = false
      this.$message.error(JSON.parse(error.message).message)
    },
    successFile(res) {
      console.log('res', res)
      this.fullscreenLoading = false
      if (res.data) {
        this.isShowtable = true
        this.title = '导入结果'
        if (res.data.error === 0) {
          this.$emit('onSuccess', res)
          this.$message.success('已成功导入' + res.data.success + '条')
          this.resData = {
            error: res.data.error || 0,
            success: res.data.success || 0
          }
          this.resultList = []
        } else {
          this.resData = {
            error: res.data.error || 0,
            success: res.data.success || 0
          }
          this.$message.error('导入失败' + res.data.error + '条')
          this.$emit('onSuccess', res)
          this.resultList = res.data.errorList || []
        }
      } else {
        this.$message.error(res.message)
      }
    },
    // 取消
    closeDialog() {
      this.title = '导入'
      this.isShowtable = false
      this.$emit('update:isShowImport', false)
      this.$nextTick(() => {
        this.resultList = []
        this.resData = {
          success: 0,
          error: 0
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
.ml20 {
  margin-left: 20px;
}

.warning {

  margin-left: 32px;
  margin-bottom: 40px;

  i {
    font-size: 16px;
    color: #1AD1B0;
  }

  span {
    margin-left: 10px;
    font-size: 14px;
    color: #999999;
  }
}

.fileName {
  display: flex;
  align-items: center;

  .downloadText {
    font-size: 14px;
    color: #1AD1B0;
  }

  .uploading {
    font-size: 14px;
    margin-left: 20px;
  }
}

.resultText {
  margin-bottom: 20px;
  font-size: 14px;
  color: #1AD1B0;
}

.resultText2 {
  margin-bottom: 20px;
  font-size: 14px;
  color: #da0e0e;
}
</style>
